import service from '@/services/brand/BrandService'

export const brandModule = {
  namespaced: true,
  strict: process.env.NODE_ENV !== 'production',
  state: {
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 10,
    },
    loadingItems: false,
    brandList: [],
  },
  mutations: {
    SET_BRAND_LIST(state, payload) {
      if (payload.current_page) {
        state.pagination.current_page = payload.current_page
        state.pagination.last_page = payload.last_page
      }
      state.brandList = payload.data ?? payload
    },
    SET_LOADING(state) {
      state.loadingItems = !state.loadingItems
    },
  },
  actions: {
    async getBrands({ commit }, query) {
      try {
        commit('SET_LOADING')
        let response = await service.getBrands(query)
        commit('SET_BRAND_LIST', response)
      } finally {
        commit('SET_LOADING')
      }
    },
    async getBrand(context, payload) {
      const response = await service.getBrand(payload)
      return response
    },
    async insertBrand({ commit, dispatch, state }, payload) {
      try {
        commit('SET_LOADING')
        const { status } = await service.insert(payload)

        dispatch('getBrands', { page: state.pagination.current_page })
        return status
      } finally {
        commit('SET_LOADING')
      }
    },
    async updateBrand({ commit, dispatch, state }, payload) {
      try {
        const form = { ...payload.form }
        commit('SET_LOADING')
        const { status } = await service.update(form, payload.id)

        dispatch('getBrands', { page: state.pagination.current_page })

        return status
      } finally {
        commit('SET_LOADING')
      }
    },
    async deleteBrand({ dispatch, state }, payload) {
      const { status } = await service.delete(payload)
      dispatch('getBrands', { page: state.pagination.current_page })
      return status
    },
  },
  getters: {
    getBrandList: (state) => state.brandList,
    getCbList: (state) => {
      return state.brandList.map((brand) => {
        return { text: brand.NOME, value: brand.NOME }
      })
    },
  },
}
